const COOKIE_NAME = 'aifc_cookies';

export function hasCookieConsent(): boolean {
  const hasCookie = document.cookie
    .split('; ')
    .some((cookie) => cookie.startsWith(`${COOKIE_NAME}=`));

  return hasCookie || localStorage.getItem(COOKIE_NAME) !== null;
}

export function acceptCookies(): void {
  const maxAge = 60 * 60 * 24 * 365;

  document.cookie =
    `${COOKIE_NAME}=accepted; ` +
    `Domain=.aifc-kz.com; ` +
    `Path=/; ` +
    `Max-Age=${maxAge}; ` +
    `SameSite=Lax; ` +
    `Secure`;

  localStorage.setItem(COOKIE_NAME, 'accepted');
}
